import QrCompose from "../helpers/QrCompose";
import withRouteProps from '@xem/entity-client-react/components/withRouteProps';
import VietBank from "../components/VietBank";
export default QrCompose(()=>{}, [ withRouteProps ], [], true)(VietBank);